import React from 'react';
import { DashboardItem } from '../../../models/Dashboard';

export type DashboardContextType = {
  initDashboardItems: DashboardItem[];
  dashboardItems: DashboardItem[];
  setDashboardItems: (
    dashboardItems:
      | DashboardItem[]
      | ((prev: DashboardItem[]) => DashboardItem[])
  ) => void;
  expandDashboardItem: (value: DashboardItem) => void;
  closeExpandedDashboardItem: () => void;
  expandedDashboardItem: DashboardItem | undefined;
};

const DashboardContext = React.createContext<DashboardContextType>({
  initDashboardItems: [],
  dashboardItems: [],
  setDashboardItems: () => {},
  expandDashboardItem: () => {},
  closeExpandedDashboardItem: () => {},
  expandedDashboardItem: undefined,
});

export default DashboardContext;
